exports = module.exports = require("../../../../../../../employee/node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".write-comment-align-ComplaintTimeLine {\n  display: -ms-flexbox !important;\n  display: flex !important;\n  background-color: #f2f2f2;\n  border: solid 1px #e6e6e6;\n  -ms-flex-align: center;\n      align-items: center;\n  padding-left: 8px;\n  padding-right: 8px;\n  /* opacity: 0.74; */\n  height: 36px;\n  margin-left: -15px;\n  margin-top: -11px; }\n\n.write-complaint-profile-cont {\n  padding: 0 !important; }\n\n.write-comment-time-cont {\n  margin-top: 4px; }\n\n.timeline-comment-style .TextArea .TextField .label-text {\n  width: 100%;\n  word-break: break-word; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!../lib/egov-ui-kit/common/pgr/complaintDetails/components/WriteComment/index.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!../lib/egov-ui-kit/common/pgr/complaintDetails/components/WriteComment/index.css
// module chunks = 504